document.addEventListener("DOMContentLoaded", function() {
  let header = document.querySelector("header");
  let prevScrollPos = window.pageYOffset;
  const detailsNavContainer = document.querySelector(".details-nav-container");
  const navLinks = document.querySelectorAll(".details-nav a.nav-link");
  const ad_infos = document.querySelectorAll("section.ad_info");
  const detailsPageHeader = document.querySelector("._ad-title-block");

  // Smooth scroll on click
  navLinks.forEach((link) => {
    link.addEventListener("click", function(e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetEl = document.getElementById(targetId);
      currentLink = targetId;
      window.scrollTo({
        top: targetEl.offsetTop + 70,
        behavior: "smooth",
      });
    });
  });

  window.addEventListener("scroll", () => {
    let clientWidth = window.innerWidth > 992 ? 40 : 45;
    let pageYOffset = window.pageYOffset;

    if (header) {
      // window.pageYOffset > 500 ? header.classList.add('shadow') : header.classList.remove('shadow');

      pageYOffset > 500
        ? header.classList.add("shadow")
        : header.classList.remove("shadow");

      let currentScrollPos = pageYOffset;

      if (currentScrollPos > 150) {
        if (detailsNavContainer && detailsPageHeader) {
          // header.style.display = pageYOffset > 150 ? "none" : "block";
          header.style.display = "none";
          detailsNavContainer.classList.add("active");
          if (window.innerWidth > 991) {
            detailsPageHeader.classList.add("active");
            detailsNavContainer.classList.add("header");
          } else {
            detailsNavContainer.classList.remove("header");
            detailsPageHeader.classList.remove("active");
          }

          let current = "";
          ad_infos.forEach((section) => {
            const sectionTop = section.offsetTop - 30; // offset for nav height
            const sectionHeight = section.clientHeight;
            if (
              pageYOffset >= sectionTop &&
              pageYOffset < sectionTop + sectionHeight
            ) {
              current = section.getAttribute("id");
            }
          });

          navLinks.forEach((link) => {
            link.classList.remove("active");
            if (link.getAttribute("href") === `#${current}`) {
              link.classList.add("active");
            }
          });
        }

        prevScrollPos > currentScrollPos
          ? (header.style.top = "0")
          : (header.style.top = `-${clientWidth}px`);
        prevScrollPos = currentScrollPos;
      } else {
        detailsNavContainer.classList.remove("active");
        detailsPageHeader.classList.remove("active");
        header.style.display = "block";
      }
    }
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/animate_header.js